import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/About.css';

const About: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-content">
          <h2>{t('about.title')}</h2>
          <p className="welcome-text">
            {t('about.description1')}
          </p>
          <p className="welcome-text">
            {t('about.description2')}
          </p>
          <button 
            className="discover-btn"
            onClick={() => {
              const gallerySection = document.getElementById('gallery');
              if (gallerySection) {
                gallerySection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') {
              const gallerySection = document.getElementById('gallery');
              if (gallerySection) {
                gallerySection.scrollIntoView({ behavior: 'smooth' });
              }
            }}}
            aria-pressed="false"
            tabIndex={0}
            onTouchStart={e => e.currentTarget.classList.add('pressed')}
            onTouchEnd={e => e.currentTarget.classList.remove('pressed')}
            onMouseDown={e => e.currentTarget.classList.add('pressed')}
            onMouseUp={e => e.currentTarget.classList.remove('pressed')}
            onBlur={e => e.currentTarget.classList.remove('pressed')}
            // British English comment: Ensures button is accessible and gives visual feedback on press
          >
            {t('about.learnMore')}
          </button>
        </div>
        <div className="about-image">
          <img 
            src={process.env.PUBLIC_URL + '/images/fihsing9.jpg'} 
            alt={t('about.imageAlt')} // British English comment: Descriptive alt text for SEO
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = process.env.PUBLIC_URL + '/images/placeholder.jpg';
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default About; 